import React, { useState } from "react";
import {
  Modal,
  Box,
  Grid,
  TextField,
  Button,
  IconButton,
  Select,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxWidth: 600,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const UserRoleModal = ({
  open,
  onClose,
  selectedUser,
  setSelectedUser,
  selectedRole,
  setSelectedRole,
  isEditing,
  setOpen,
}) => {
  const onSubmit = () => {
    setOpen(false);
  };
  return (
    <Modal
      open={open}
      onClose={(e) => e.stopPropagation()}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Box sx={modalStyle} onClick={(e) => e.stopPropagation()}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          style={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "black",
          }}
        >
          <CloseIcon />
        </IconButton>
        <Grid container spacing={2} mt={2}>
          <Grid item xs={12} sm={12} md={12}>
            <TextField label="Name" variant="outlined" fullWidth />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <TextField label="Email" variant="outlined" fullWidth />
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <TextField label="Mobile Number" variant="outlined" fullWidth />
          </Grid>
          <Grid item xs={12} md={12}>
            <Button
              variant="contained"
              color="primary"
              onClick={onSubmit}
              fullWidth
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default UserRoleModal;
